<template>
  <v-container fluid>
    <v-row>
      <v-col cols="6">
        <evaluado-info-card-component :expediente="expediente[0]" />
      </v-col>
      <v-col cols="12">
        <div class="text-h6 font-weight-bold">
          Grupo sanguíneo, servicio médico y accidentes laborales
        </div>
        <v-stepper
          v-model="grupoSanguineoStepper"
          vertical
          class="primary"
        >
          <v-stepper-step
            editable
            color="secondary"
            step="1"
          >
            Grupo sanguíneo y servicio médico
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-container>
              <v-row>
                <v-col
                  cols="4"
                  offset-md="4"
                >
                  <v-select
                    v-model="historiaClinica.fk_idCatGrupoSanguineo"
                    label="Grupo sanguíneo"
                    :items="grupoSanguineo"
                    item-value="id"
                    item-text="title"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    item-color="secondary"
                  />
                </v-col>
                <v-col
                  cols="4"
                  offset-md="4"
                >
                  <v-select
                    v-model="historiaClinica.fk_idCatServicioMedico"
                    label="Servicio médico"
                    :items="servicioMedico"
                    item-value="id"
                    item-text="title"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    item-color="secondary"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-btn
                    text
                    rounded
                    class="mx-2"
                    @click="grupoSanguineoStepper--"
                  >
                    Anterior
                  </v-btn>
                  <v-btn
                    color="secondary"
                    rounded
                    class="px-8 mx-2"
                    @click="grupoSanguineoStepper++"
                  >
                    Siguiente
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>
          <v-stepper-step
            editable
            color="secondary"
            step="2"
          >
            Accidentes laborales
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-container>
              <v-row align="center">
                <v-col cols="4">
                  <v-checkbox
                    v-model="checkAccidentesLaborales"
                    label="¿Ha sufrido algún accidente en el trabajo?"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="accidenteLaboral.descripcion"
                    label="Descripción"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    :disabled="!checkAccidentesLaborales"
                  />
                </v-col>
                <v-col cols="2">
                  <v-select
                    v-model="accidenteLaboral.fk_idCatTiempo"
                    label="Tiempo"
                    :items="tiempos"
                    item-value="id"
                    item-text="title"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    item-color="secondary"
                  />
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="4">
                  <v-checkbox
                    v-model="accidenteLaboral.complicacionesDerivadas"
                    label="¿Existe alguna complicación derivado del accidente?"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    v-model="accidenteLaboral.detalleComplicacionesDerivadas"
                    label="¿Cuál?"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    :disabled="!accidenteLaboral.complicacionesDerivadas"
                  />
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="4">
                  <v-checkbox
                    v-model="historiaClinica.incapacidadVidaLaboral"
                    label="¿Ha tenido incapacidades durante su vida laboral?"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    v-model="historiaClinica.motivoIncapacidad"
                    label="Motivo"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    :disabled="!historiaClinica.incapacidadVidaLaboral"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-btn
                    text
                    rounded
                    class="mx-2"
                    @click="grupoSanguineoStepper--"
                  >
                    Anterior
                  </v-btn>
                  <v-btn
                    color="secondary"
                    rounded
                    class="px-8 mx-2"
                    @click="grupoSanguineoStepper++"
                  >
                    Finalizar
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>
        </v-stepper>

        <div class="text-h6 font-weight-bold">
          Antecedentes heredo-familiares
        </div>
        <v-card
          color="primary"
          class="card"
        >
          <v-data-table
            :headers="antecedentesHeredofamiliaresHeaders"
            :items="patologicas"
            hide-default-footer
            class="transparent"
          >
            <template #[`item.madre`]="{ item }">
              <v-checkbox
                on-icon="mdi-check"
                color="secondary"
                @change="toggleAntecedenteHeredofamiliar($event, item.id, 1)"
              />
            </template>
            <template #[`item.padre`]="{ item }">
              <v-checkbox
                on-icon="mdi-check"
                color="secondary"
                @change="toggleAntecedenteHeredofamiliar($event, item.id, 2)"
              />
            </template>
            <template #[`item.abuelos`]="{ item }">
              <v-checkbox
                on-icon="mdi-check"
                color="secondary"
                @change="toggleAntecedenteHeredofamiliar($event, item.id, 3)"
              />
            </template>
            <template #[`item.hermanos`]="{ item }">
              <v-checkbox
                on-icon="mdi-check"
                color="secondary"
                @change="toggleAntecedenteHeredofamiliar($event, item.id, 4)"
              />
            </template>
          </v-data-table>
        </v-card>

        <div class="text-h6 font-weight-bold">
          Antecedentes personales no patológicos
        </div>
        <v-stepper
          v-model="antecedentesPersonalesStepper"
          vertical
          class="primary"
        >
          <v-stepper-step
            editable
            color="secondary"
            step="1"
          >
            Ejercicio y deporte
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-container>
              <v-row align="center">
                <v-col>
                  <v-checkbox
                    v-model="checkDeporte"
                    label="¿El evaluado practica algún deporte?"
                    color="secondary"
                    on-icon="mdi-check"
                  />
                </v-col>
                <v-col
                  cols="4"
                  offset-md="4"
                >
                  <v-select
                    v-model="deportes"
                    label="Deportes o ejercicios físicos que realiza"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    item-color="secondary"
                    :items="tipoEjercicio"
                    item-value="fk_idTipoEjercicio"
                    item-text="tipoEjercicio"
                    return-object
                    multiple
                    :disabled="!checkDeporte"
                  />
                </v-col>
                <v-col
                  v-if="checkDeporte"
                  cols="12"
                >
                  <v-data-table
                    :items="deportes"
                    :headers="deportesHeaders"
                    hide-default-footer
                    class="primary"
                  >
                    <template #[`item.fk_idTiempo`]="{ item }">
                      <v-select
                        v-model="item.fk_idCatTiempo"
                        label="Tiempo"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        item-color="secondary"
                        :items="filteredTiempoHoras"
                        item-value="id"
                        item-text="title"
                        class="mt-6"
                      />
                    </template>
                    <template #[`item.fk_idFrecuencia`]="{ item }">
                      <v-slider
                        v-model="item.fk_idCatFrecuencia"
                        color="secondary"
                        ticks
                        step="1"
                        tick-size="5"
                        min="1"
                        max="5"
                        :tick-labels="frecuencias"
                      />
                    </template>
                    <template #[`item.opciones`]="{ item }">
                      <v-btn
                        icon
                        @click="quitaDeporte(item)"
                      >
                        <v-icon color="error">
                          mdi-minus-circle
                        </v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-btn
                    text
                    rounded
                    class="mx-2"
                    @click="antecedentesPersonalesStepper--"
                  >
                    Anterior
                  </v-btn>
                  <v-btn
                    color="secondary"
                    rounded
                    class="px-8 mx-2"
                    @click="antecedentesPersonalesStepper++"
                  >
                    Siguiente
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>
          <v-stepper-step
            editable
            color="secondary"
            step="2"
          >
            Tipo de dieta
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-container>
              <v-row>
                <v-col cols="4">
                  <v-select
                    v-model="carnes.fk_idCatFrecuencia"
                    label="Carnes"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    :items="frecuenciasLista"
                    item-text="title"
                    item-value="id"
                    item-color="secondary"
                  />
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    v-model="carnes.otra"
                    label="Observaciones sobre consumo de carnes"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <v-select
                    v-model="cereales.fk_idCatFrecuencia"
                    label="Cereales y leguminosas"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    :items="frecuenciasLista"
                    item-text="title"
                    item-value="id"
                    item-color="secondary"
                  />
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    v-model="cereales.otra"
                    label="Observaciones sobre consumo de cereales y leguminosas"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <v-select
                    v-model="frutas.fk_idCatFrecuencia"
                    label="Frutas y verduras"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    :items="frecuenciasLista"
                    item-text="title"
                    item-value="id"
                    item-color="secondary"
                  />
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    v-model="frutas.otra"
                    label="Observaciones sobre consumo de frutas y verduras"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <v-select
                    v-model="lacteos.fk_idCatFrecuencia"
                    label="Lácteos"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    :items="frecuenciasLista"
                    item-text="title"
                    item-value="id"
                    item-color="secondary"
                  />
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    v-model="lacteos.otra"
                    label="Observaciones sobre consumo de lácteos"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-btn
                    text
                    rounded
                    class="mx-2"
                    @click="antecedentesPersonalesStepper--"
                  >
                    Anterior
                  </v-btn>
                  <v-btn
                    color="secondary"
                    rounded
                    class="px-8 mx-2"
                    @click="antecedentesPersonalesStepper++"
                  >
                    Siguiente
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>
          <v-stepper-step
            editable
            color="secondary"
            step="3"
          >
            Zoonosis
          </v-stepper-step>
          <v-stepper-content step="3">
            <v-container>
              <v-row>
                <v-col
                  cols="4"
                  offset-md="4"
                >
                  <v-select
                    v-model="zoonosis"
                    label="¿Padece algún tipo de zoonosis?"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    item-color="secondary"
                    :items="tipoZoonosis"
                    item-value="id"
                    item-text="title"
                    return-object
                    multiple
                  />
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    :items="zoonosis"
                    :headers="zoonosisHeaders"
                    hide-default-footer
                    class="primary"
                  >
                    <template #[`item.detalle`]="{ item }">
                      <v-text-field
                        v-model="item.detalle"
                        label="Detalle de zoonosis"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        class="mt-6"
                      />
                    </template>
                    <template #[`item.opciones`]="{ item }">
                      <v-btn
                        icon
                        @click="quitaZoonosis(item)"
                      >
                        <v-icon color="error">
                          mdi-minus-circle
                        </v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-btn
                    text
                    rounded
                    class="mx-2"
                    @click="antecedentesPersonalesStepper--"
                  >
                    Anterior
                  </v-btn>
                  <v-btn
                    color="secondary"
                    rounded
                    class="px-8 mx-2"
                    @click="antecedentesPersonalesStepper++"
                  >
                    Finalizar
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>
        </v-stepper>

        <div class="text-h6 font-weight-bold">
          Antecedentes personales patológicos
        </div>
        <v-stepper
          v-model="antecedentesPersonalesPatStepper"
          vertical
          class="primary"
        >
          <v-stepper-step
            editable
            color="secondary"
            step="1"
          >
            Enfermedades actuales
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-container>
              <v-row align="center">
                <v-col>
                  <v-checkbox
                    v-model="checkEnfermedades"
                    label="¿El evaluado padece alguna enfermedad?"
                    on-icon="mdi-check"
                    color="secondary"
                  />
                </v-col>
                <v-col
                  cols="4"
                  offset-md="4"
                >
                  <v-select
                    v-model="patologico.enfermedades"
                    label="Enfermedades que padece actualmente"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    item-color="secondary"
                    :items="listaEnfermedades"
                    item-value="fk_idEnfermedad"
                    item-text="enfermedad"
                    return-object
                    multiple
                    :disabled="!checkEnfermedades"
                  />
                </v-col>
                <v-col
                  v-if="checkEnfermedades"
                  cols="12"
                >
                  <v-data-table
                    :items="patologico.enfermedades"
                    :headers="enfermedadesActualesHeaders"
                    hide-default-footer
                    class="primary"
                  >
                    <template #[`item.fechaInicio`]="{ item, index }">
                      <v-menu
                        ref="menu8"
                        v-model="menu8[index]"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template #activator="{ on, attrs }">
                          <v-text-field
                            v-model="item.fechaInicio"
                            label="Fecha de inicio"
                            append-icon="mdi-calendar"
                            v-bind="attrs"
                            rounded
                            filled
                            dense
                            background-color="primary"
                            color="secondary"
                            class="mt-6"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="item.fechaInicio"
                          no-title
                          @input="menu8[index] = false"
                        />
                      </v-menu>
                    </template>
                    <template #[`item.fechaFin`]="{ item, index }">
                      <v-menu
                        ref="menu9"
                        v-model="menu9[index]"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template #activator="{ on, attrs }">
                          <v-text-field
                            v-model="item.fechaFin"
                            label="Fecha de fin"
                            append-icon="mdi-calendar"
                            v-bind="attrs"
                            rounded
                            filled
                            dense
                            background-color="primary"
                            color="secondary"
                            class="mt-6"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="item.fechaFin"
                          no-title
                          @input="menu9[index] = false"
                        />
                      </v-menu>
                    </template>
                    <template #[`item.detalle`]="{ item }">
                      <v-row align="center">
                        <v-checkbox
                          v-model="item.tratamientoMedico"
                          color="secondary"
                          class="mx-4"
                        />
                        <v-text-field
                          v-model="item.detalle"
                          label="Detalle de tratamiento"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          class="mt-6"
                        />
                      </v-row>
                    </template>
                    <template #[`item.opciones`]="{ item }">
                      <v-btn
                        icon
                        @click="quitaEnfermedadActual(item)"
                      >
                        <v-icon color="error">
                          mdi-minus-circle
                        </v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-btn
                    color="secondary"
                    rounded
                    class="px-8 mx-2"
                    @click="antecedentesPersonalesPatStepper++"
                  >
                    Siguiente
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>
          <v-stepper-step
            editable
            color="secondary"
            step="2"
          >
            Información adicional
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-container>
              <v-row>
                <v-col cols="3">
                  <v-checkbox
                    v-model="patologico.hospitalizacion"
                    label="¿Ha sido hospitalizado?"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="9">
                  <v-text-field
                    v-model="patologico.detalleHospitalizacion"
                    :disabled="!patologico.hospitalizacion"
                    label="¿Cuál fue el motivo?"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="3">
                  <v-checkbox
                    v-model="patologico.quirurgicos"
                    label="¿Quirúrgicos?"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="9">
                  <v-text-field
                    v-model="patologico.detalleQuirurgicos"
                    :disabled="!patologico.quirurgicos"
                    label="¿Cuáles?"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="3">
                  <v-checkbox
                    v-model="patologico.trasfuncionales"
                    label="¿Transfusionales?"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="9">
                  <v-text-field
                    v-model="patologico.detalleTransfucionales"
                    :disabled="!patologico.trasfuncionales"
                    label="¿Cuál fue el motivo?"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <!-- <v-col cols="3">
                                    <v-checkbox label="¿Traumatismos o fracturas?" color="secondary"></v-checkbox>
                                </v-col>
                                <v-col cols="9">
                                    <v-text-field
                                        label="¿Cuál fue el motivo?"
                                        rounded
                                        filled
                                        dense
                                        background-color="primary"
                                        color="secondary"
                                    ></v-text-field>
                                </v-col> -->
                <v-col cols="3">
                  <v-checkbox
                    v-model="patologico.rehabilitacionFisica"
                    label="¿Rehabilitación física?"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="9">
                  <v-text-field
                    v-model="patologico.detalleRehabilitacionFisica"
                    :disabled="!patologico.rehabilitacionFisica"
                    label="¿Qué tiempo acudió?"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="3">
                  <v-checkbox
                    v-model="patologico.alergias"
                    label="¿Alergias?"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="9">
                  <v-text-field
                    v-model="patologico.detalleAlergias"
                    :disabled="!patologico.alergias"
                    label="¿Qué tipo de alergias?"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="3">
                  <v-checkbox
                    v-model="patologico.terapiaPsicologica"
                    label="¿Terapias psicológicas?"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="9">
                  <v-text-field
                    v-model="patologico.detalleTerapiaPsicologica"
                    :disabled="!patologico.terapiaPsicologica"
                    label="¿Cuál fue el motivo?"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="3">
                  <v-checkbox
                    v-model="patologico.terapiaPsiquiatrica"
                    label="¿Terapias psiquiátricas?"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="9">
                  <v-text-field
                    v-model="patologico.detalleTerapiaPsiquiatrica"
                    :disabled="!patologico.terapiaPsiquiatrica"
                    label="¿Cuál fue el motivo?"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="patologico.ultimaVacuna"
                    label="Última vacuna aplicada"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col
                  cols="7"
                  offset-md="1"
                >
                  <v-textarea
                    label="Enfermedades exatemáticas"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    no-resize
                    rows="9"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-btn
                    text
                    rounded
                    class="mx-2"
                    @click="antecedentesPersonalesPatStepper--"
                  >
                    Anterior
                  </v-btn>
                  <v-btn
                    color="secondary"
                    rounded
                    class="px-8 mx-2"
                    @click="antecedentesPersonalesPatStepper++"
                  >
                    Siguiente
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>
          <v-stepper-step
            editable
            color="secondary"
            step="3"
          >
            Consumo de drogas
          </v-stepper-step>
          <v-stepper-content step="3">
            <v-container>
              <v-row>
                <v-col cols="4">
                  <v-checkbox
                    v-model="checkDrogas"
                    label="¿A lo largo de su vida ha consumido algún tipo de droga?"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="4">
                  <v-select
                    v-model="patologico.drogas"
                    label="¿Qué drogas ha consumido?"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    item-color="secondary"
                    :items="listaDrogas"
                    item-value="fk_idDroga"
                    item-text="droga"
                    return-object
                    multiple
                    :disabled="!checkDrogas"
                  />
                </v-col>
                <v-col
                  v-if="checkDrogas"
                  cols="12"
                >
                  <v-data-table
                    :items="patologico.drogas"
                    :headers="drogasConsumidasHeaders"
                    hide-default-footer
                    class="primary"
                  >
                    <template #[`item.motivo`]="{ item }">
                      <v-text-field
                        v-model="item.motivo"
                        label="Motivo de consumo"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        class="mt-6"
                      />
                    </template>
                    <template #[`item.edadConsumo`]="{ item }">
                      <v-text-field
                        v-model.number="item.edadConsumo"
                        type="number"
                        label="Edad"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        class="mt-6"
                      />
                    </template>
                    <template #[`item.cantidadConsumo`]="{ item }">
                      <v-text-field
                        v-model="item.cantidadConsumo"
                        label="Cantidad"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        class="mt-6"
                      />
                    </template>
                    <template #[`item.ultimoConsumo`]="{ item, index }">
                      <v-menu
                        ref="menu8"
                        v-model="fechaUltimoConsumoDroga[index]"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template #activator="{ on, attrs }">
                          <v-text-field
                            v-model="item.ultimoConsumo"
                            label="Fecha de inicio"
                            append-icon="mdi-calendar"
                            v-bind="attrs"
                            rounded
                            filled
                            dense
                            background-color="primary"
                            color="secondary"
                            class="mt-6"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="item.ultimoConsumo"
                          no-title
                          @input="fechaUltimoConsumoDroga[index] = false"
                        />
                      </v-menu>
                    </template>
                    <template #[`item.consumoActual`]="{ item }">
                      <v-checkbox
                        v-model="item.consumoActual"
                        color="secondary"
                      />
                    </template>
                    <template #[`item.combinacionConAlcohol`]="{ item }">
                      <v-checkbox
                        v-model="item.combinacionConAlcohol"
                        color="secondary"
                        class="mt-5"
                      />
                    </template>
                    <template #[`item.consumoCompania`]="{ item }">
                      <v-row align="center">
                        <v-checkbox
                          v-model="item.consumoCompania"
                          color="secondary"
                          hide-details
                          class="mt-0"
                        />
                        <v-text-field
                          label="¿Quiénes?"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          class="mt-6"
                          :disabled="!item.consumoCompania"
                        />
                      </v-row>
                    </template>
                    <template #[`item.opciones`]="{ item }">
                      <v-btn
                        icon
                        @click="quitaDroga(item)"
                      >
                        <v-icon color="error">
                          mdi-minus-circle
                        </v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <v-checkbox
                    label="¿Conoce alguna droga físicamente?"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    label="¿Cuáles?"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-btn
                    text
                    rounded
                    class="mx-2"
                    @click="antecedentesPersonalesPatStepper--"
                  >
                    Anterior
                  </v-btn>
                  <v-btn
                    color="secondary"
                    rounded
                    class="px-8 mx-2"
                    @click="antecedentesPersonalesPatStepper++"
                  >
                    Siguiente
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>
          <v-stepper-step
            editable
            color="secondary"
            step="4"
          >
            Consumo de medicamentos controlados
          </v-stepper-step>
          <v-stepper-content step="4">
            <v-container>
              <v-row>
                <v-col cols="6">
                  <v-checkbox
                    label="¿A lo largo de su vida ha consumido medicamentos para dormir, mantenerse despierto o bajar de peso?"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="4">
                  <v-select
                    v-model="patologico.medicamentosControlados"
                    label="¿Qué medicamentos consumió?"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    item-color="secondary"
                    :items="listaMedicamentosControlados"
                    item-value="fk_idMedicamento"
                    item-text="medicamento"
                    return-object
                    multiple
                  />
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    :items="patologico.medicamentosControlados"
                    :headers="medicamentosConsumidosHeaders"
                    hide-default-footer
                    class="primary"
                  >
                    <template #[`item.receto`]="{ item }">
                      <v-text-field
                        v-model="item.receto"
                        label="¿Quién se lo recetó?"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        class="mt-6"
                      />
                    </template>
                    <template #[`item.tieneReceta`]="{ item }">
                      <v-checkbox
                        v-model="item.tieneReceta"
                        color="secondary"
                        class="mt-5"
                      />
                    </template>
                    <template #[`item.fechaInicio`]="{ item, index }">
                      <v-menu
                        ref="menu8"
                        v-model="fechaConsumoMedicamentoControlado[index]"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template #activator="{ on, attrs }">
                          <v-text-field
                            v-model="item.fechaInicio"
                            label="Fecha de inicio"
                            append-icon="mdi-calendar"
                            v-bind="attrs"
                            rounded
                            filled
                            dense
                            background-color="primary"
                            color="secondary"
                            class="mt-6"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="item.fechaInicio"
                          no-title
                          @input="fechaConsumoMedicamentoControlado[index] = false"
                        />
                      </v-menu>
                    </template>
                    <template #[`item.lugarConsiguio`]="{ item }">
                      <v-text-field
                        v-model="item.lugarConsiguio"
                        label="Lugar donde consiguió"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        class="mt-6"
                      />
                    </template>
                    <template #[`item.dosisDetalle`]="{ item }">
                      <v-text-field
                        v-model="item.dosisDetalle"
                        label="Dosis indicada"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        class="mt-6"
                      />
                    </template>
                    <template #[`item.opciones`]="{ item }">
                      <v-btn
                        icon
                        @click="quitaMedicamento(item)"
                      >
                        <v-icon color="error">
                          mdi-minus-circle
                        </v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
                <v-row>
                  <v-col
                    cols="12"
                    align="center"
                  >
                    <v-btn
                      text
                      rounded
                      class="mx-2"
                      @click="antecedentesPersonalesPatStepper--"
                    >
                      Anterior
                    </v-btn>
                    <v-btn
                      color="secondary"
                      rounded
                      class="px-8 mx-2"
                      @click="antecedentesPersonalesPatStepper++"
                    >
                      Siguiente
                    </v-btn>
                  </v-col>
                </v-row>
              </v-row>
            </v-container>
          </v-stepper-content>
          <v-stepper-step
            editable
            color="secondary"
            step="5"
          >
            Consumo de tabaco
          </v-stepper-step>
          <v-stepper-content step="5">
            <v-container>
              <v-row align="center">
                <v-col cols="2">
                  <v-checkbox
                    label="¿Alguna vez ha fumado?"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model.number="patologico.consumosTabaco[0].edadInicio"
                    label="Edad a la que comenzó a fumar"
                    type="number"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    class="mt-6"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model.number="patologico.consumosTabaco[0].cantidadConsumo"
                    label="Cantidad de consumo"
                    type="number"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    class="mt-6"
                  />
                </v-col>
                <v-col cols="6">
                  <v-slider
                    v-model="patologico.consumosTabaco[0].fk_idFrecuencia"
                    color="secondary"
                    min="1"
                    max="5"
                    ticks
                    step="1"
                    tick-size="5"
                    :tick-labels="frecuencias"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-btn
                    text
                    rounded
                    class="mx-2"
                    @click="antecedentesPersonalesPatStepper--"
                  >
                    Anterior
                  </v-btn>
                  <v-btn
                    color="secondary"
                    rounded
                    class="px-8 mx-2"
                    @click="antecedentesPersonalesPatStepper++"
                  >
                    Siguiente
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>
          <v-stepper-step
            editable
            color="secondary"
            step="6"
          >
            Consumo de alcohol
          </v-stepper-step>
          <v-stepper-content step="6">
            <v-container>
              <v-row align="center">
                <v-col cols="2">
                  <v-checkbox
                    label="¿Ingiere bebidas alcohólicas?"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model.number="patologico.consumosAlcohol[0].edadInicio"
                    label="Edad a la que comenzó a beber"
                    type="number"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    class="mt-6"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model.number="patologico.consumosAlcohol[0].cantidad"
                    label="Cantidad de consumo"
                    type="number"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    class="mt-6"
                  />
                </v-col>
                <v-col cols="6">
                  <v-slider
                    v-model="patologico.consumosAlcohol[0].fk_idCatFrecuencia"
                    color="secondary"
                    ticks
                    min="1"
                    max="5"
                    step="1"
                    tick-size="5"
                    :tick-labels="frecuencias"
                  />
                </v-col>
              </v-row>
              <v-row align="center">
                <!-- <v-col cols="2">
                                    <v-checkbox label="¿Llegó a la embriaguez?" color="secondary"></v-checkbox>
                                </v-col> -->
                <v-col cols="2">
                  <v-select
                    v-model="patologico.consumosAlcohol[0].fk_idCatNivelConsumoAlcohol"
                    label="Nivel de consumo"
                    :items="nivelConsumoAlcohol"
                    item-value="id"
                    item-text="descripcion"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    item-color="secondary"
                  />
                </v-col>
                <v-col cols="2">
                  <v-select
                    v-model="patologico.consumosAlcohol[0].fk_idCatTipoBebida"
                    label="Tipo de bebida"
                    :items="tipoBebida"
                    item-value="id"
                    item-text="title"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    item-color="secondary"
                  />
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="4">
                  <v-checkbox
                    label="¿Ha tenido algún problema por su forma de tomar?"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    v-model="patologico.consumosAlcohol[0].problemasGenerados"
                    label="¿Cuál?"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    class="mt-6"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-btn
                    text
                    rounded
                    class="mx-2"
                    @click="antecedentesPersonalesPatStepper--"
                  >
                    Anterior
                  </v-btn>
                  <v-btn
                    v-if="expediente[0].Personal.fk_idSexo === 1"
                    color="secondary"
                    rounded
                    class="px-8 mx-2"
                    @click="antecedentesPersonalesPatStepper++"
                  >
                    Siguiente
                  </v-btn>
                  <v-btn
                    v-else
                    color="secondary"
                    rounded
                    class="px-8 mx-2"
                    @click="antecedentesPersonalesPatStepper = 8"
                  >
                    Siguiente
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>
          <v-stepper-step
            color="secondary"
            step="7"
            :editable="expediente[0].Personal.fk_idSexo !== 2"
          >
            Antecedentes androgénicos
          </v-stepper-step>
          <v-stepper-content step="7">
            <v-container>
              <v-row>
                <v-col cols="8">
                  <v-row>
                    <v-col cols="4">
                      <v-text-field
                        v-model="androgenicos.ivsa"
                        label="IVSA"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        class="mt-6"
                      />
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        v-model.number="androgenicos.noParejasSexuales"
                        type="number"
                        label="Número de parejas sexuales"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        class="mt-6"
                      />
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        v-model.number="androgenicos.inicioPubertad"
                        type="number"
                        label="Inicio de la pubertad"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        class="mt-6"
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="androgenicos.antecedentesETS"
                        label="Antecedentes de enfermedades de transmisión sexual"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        class="mt-6"
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="androgenicos.metodoPlanificacion"
                        label="Método de planificación"
                        number
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        class="mt-6"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  cols="4"
                  align="center"
                >
                  <div class="text-subtitle-1 font-weight-bold">
                    Fecha de detección oportuna de cáncer prostático
                  </div>
                  <v-date-picker
                    v-model="androgenicos.deteccionCancerProstatico"
                    locale="es"
                    color="secondary"
                    no-title
                    full-width
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-btn
                    text
                    rounded
                    class="mx-2"
                    @click="antecedentesPersonalesPatStepper--"
                  >
                    Anterior
                  </v-btn>
                  <v-btn
                    color="secondary"
                    rounded
                    class="px-8 mx-2"
                    @click="antecedentesPersonalesPatStepper = 9"
                  >
                    Siguiente
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>
          <v-stepper-step
            color="secondary"
            step="8"
            :editable="expediente[0].Personal.fk_idSexo !== 1"
          >
            Antecedentes gineco-obstétricos
          </v-stepper-step>
          <v-stepper-content step="8">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="4">
                      <v-text-field
                        v-model="gineco.menarca"
                        label="Menarca"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        class="mt-6"
                      />
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        v-model="gineco.ciclos"
                        label="Ciclos"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        class="mt-6"
                      />
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        v-model="gineco.metodoPlanificacion"
                        label="Método de planificación"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        class="mt-6"
                      />
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        v-model="gineco.ets"
                        label="Enfermedades de transmisión sexual"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        class="mt-6"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-row align="center">
                    <v-col cols="3">
                      <v-text-field
                        v-model.number="gineco.noGestas"
                        type="number"
                        label="Numero de gestas"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        class="mt-6"
                      />
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                        v-model.number="gineco.partos"
                        type="number"
                        label="Numero de partos"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        class="mt-6"
                      />
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                        v-model.number="gineco.cesareas"
                        type="number"
                        label="Numero de cesáreas"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        class="mt-6"
                      />
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                        v-model.number="gineco.abortos"
                        type="number"
                        label="Numero de abortos"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        class="mt-6"
                      />
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                        v-model.number="gineco.noParejasSexuales"
                        type="number"
                        label="Numero de parejas sexuales"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        class="mt-6"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-row align="center">
                    <v-col cols="4">
                      <v-menu
                        ref="menu1"
                        v-model="ultimaMestruacionMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template #activator="{ on, attrs }">
                          <v-text-field
                            v-model="gineco.ultimaMestruacion"
                            label="Fecha de última menstruación"
                            append-icon="mdi-calendar"
                            v-bind="attrs"
                            rounded
                            filled
                            dense
                            background-color="primary"
                            color="secondary"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="gineco.ultimaMestruacion"
                          no-title
                          @input="ultimaMestruacionMenu = false"
                        />
                      </v-menu>
                    </v-col>
                    <v-col cols="4">
                      <v-menu
                        ref="menu2"
                        v-model="inicioVidaSexualMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template #activator="{ on, attrs }">
                          <v-text-field
                            v-model="gineco.inicioVidaSexual"
                            label="Fecha de inicio de vida sexual"
                            append-icon="mdi-calendar"
                            v-bind="attrs"
                            rounded
                            filled
                            dense
                            background-color="primary"
                            color="secondary"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="gineco.inicioVidaSexual"
                          no-title
                          @input="inicioVidaSexualMenu = false"
                        />
                      </v-menu>
                    </v-col>
                    <v-col cols="4">
                      <v-menu
                        ref="menu4"
                        v-model="deteccionCancerMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template #activator="{ on, attrs }">
                          <v-text-field
                            v-model="gineco.deteccionCancer"
                            label="Detección oportuna de cáncer"
                            append-icon="mdi-calendar"
                            v-bind="attrs"
                            rounded
                            filled
                            dense
                            background-color="primary"
                            color="secondary"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="gineco.deteccionCancer"
                          no-title
                          @input="deteccionCancerMenu = false"
                        />
                      </v-menu>
                    </v-col>
                    <v-col cols="4">
                      <v-menu
                        ref="menu5"
                        v-model="ultimoPartoMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template #activator="{ on, attrs }">
                          <v-text-field
                            v-model="gineco.ultimoParto"
                            label="Último parto"
                            append-icon="mdi-calendar"
                            v-bind="attrs"
                            rounded
                            filled
                            dense
                            background-color="primary"
                            color="secondary"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="gineco.ultimoParto"
                          no-title
                          @input="ultimoPartoMenu = false"
                        />
                      </v-menu>
                    </v-col>
                    <v-col cols="4">
                      <v-menu
                        ref="menu6"
                        v-model="ultimaCesareaMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template #activator="{ on, attrs }">
                          <v-text-field
                            v-model="gineco.ultimaCesarea"
                            label="Última cesárea"
                            append-icon="mdi-calendar"
                            v-bind="attrs"
                            rounded
                            filled
                            dense
                            background-color="primary"
                            color="secondary"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="gineco.ultimaCesarea"
                          no-title
                          @input="ultimaCesareaMenu = false"
                        />
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-btn
                    text
                    rounded
                    class="mx-2"
                    @click="antecedentesPersonalesPatStepper--"
                  >
                    Anterior
                  </v-btn>
                  <v-btn
                    color="secondary"
                    rounded
                    class="px-8 mx-2"
                    @click="antecedentesPersonalesPatStepper++"
                  >
                    Siguiente
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>
          <v-stepper-step
            editable
            color="secondary"
            step="9"
          >
            Medicaciones
          </v-stepper-step>
          <v-stepper-content step="9">
            <v-container>
              <v-container>
                <v-row>
                  <v-col cols="6">
                    <v-checkbox
                      label="¿Actualmente se encuentra medicado?"
                      color="secondary"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-select
                      v-model="medicamentosActuales"
                      label="¿Qué medicamentos consumió?"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      item-color="secondary"
                      :items="listaMedicamentosActuales"
                      item-value="fk_idCatMedicamento"
                      item-text="medicamento"
                      return-object
                      multiple
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-data-table
                      :items="medicamentosActuales"
                      :headers="medicamentosActualesHeaders"
                      hide-default-footer
                      class="primary"
                    >
                      <template #[`item.medicacionActual`]="{ }">
                        <v-checkbox
                          color="secondary"
                          class="mt-5"
                        />
                      </template>
                      <template #[`item.controlado`]="{ }">
                        <v-checkbox
                          color="secondary"
                          class="mt-5"
                        />
                      </template>
                      <template #[`item.fecha`]="{ item, index }">
                        <v-menu
                          ref="menu1"
                          v-model="fechaMedicamentoActualMenu[index]"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="auto"
                        >
                          <template #activator="{ on, attrs }">
                            <v-text-field
                              v-model="item.fechaInicioFin"
                              label="Rango de fechas de consumo"
                              append-icon="mdi-calendar"
                              v-bind="attrs"
                              rounded
                              filled
                              dense
                              background-color="primary"
                              color="secondary"
                              class="mt-6"
                              v-on="on"
                            />
                          </template>
                          <v-date-picker
                            v-model="item.fechaInicioFin"
                            no-title
                            range
                          />
                        </v-menu>
                      </template>
                      <template #[`item.diagnosticoTratamiento`]="{ item }">
                        <v-text-field
                          v-model="item.diagnosticoTratamiento"
                          label="Diagnóstico de tratamiento"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          class="mt-6"
                        />
                      </template>
                      <template #[`item.opciones`]="{ item }">
                        <v-btn
                          icon
                          @click="quitaMedicamentoActual(item)"
                        >
                          <v-icon color="error">
                            mdi-minus-circle
                          </v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-col>
                  <v-row>
                    <v-col
                      cols="12"
                      align="center"
                    >
                      <v-btn
                        text
                        rounded
                        class="mx-2"
                        @click="antecedentesPersonalesPatStepper--"
                      >
                        Anterior
                      </v-btn>
                      <v-btn
                        color="secondary"
                        rounded
                        class="px-8 mx-2"
                        @click="antecedentesPersonalesPatStepper++"
                      >
                        Finalizar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-row>
              </v-container>
            </v-container>
          </v-stepper-content>
        </v-stepper>

        <div class="text-h6 font-weight-bold">
          Interrogatorio por aparatos y sistemas
        </div>
        <v-card
          class="card"
          color="primary"
        >
          <v-card-text>
            <v-container
              v-for="(interrogatorioAparato, index) in interrogatorioAS"
              :key="index"
            >
              <v-row>
                <v-col cols="12">
                  <div
                    v-if="interrogatorioAparato.fk_idCatAparatoSistema === 1"
                    class="text-h6 font-weight-bold"
                  >
                    Aparato cardiovascular
                  </div>
                  <div
                    v-if="interrogatorioAparato.fk_idCatAparatoSistema === 2"
                    class="text-h6 font-weight-bold"
                  >
                    Aparato respiratorio
                  </div>
                  <div
                    v-if="interrogatorioAparato.fk_idCatAparatoSistema === 3"
                    class="text-h6 font-weight-bold"
                  >
                    Sistema genitourinario
                  </div>
                  <div
                    v-if="interrogatorioAparato.fk_idCatAparatoSistema === 4"
                    class="text-h6 font-weight-bold"
                  >
                    Sistema endocrino
                  </div>
                  <div
                    v-if="interrogatorioAparato.fk_idCatAparatoSistema === 5"
                    class="text-h6 font-weight-bold"
                  >
                    Sistema neurológico
                  </div>
                  <div
                    v-if="interrogatorioAparato.fk_idCatAparatoSistema === 6"
                    class="text-h6 font-weight-bold"
                  >
                    Aparato digestivo
                  </div>
                  <div
                    v-if="interrogatorioAparato.fk_idCatAparatoSistema === 7"
                    class="text-h6 font-weight-bold"
                  >
                    Aparato locomotor
                  </div>
                </v-col>
                <v-col cols="6">
                  <v-list
                    v-if="interrogatorioAparato.fk_idCatAparatoSistema === 1"
                    dense
                    color="primary"
                  >
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Dolor en pecho</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Palpitaciones</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Disnea</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Síncope</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Ortostasis</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Acúfenos</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Fosfenos</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <v-list
                    v-if="interrogatorioAparato.fk_idCatAparatoSistema === 2"
                    dense
                    color="primary"
                  >
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Tos</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Esputo</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Hemopitisis</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Disnea</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Sibilancias</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Cianosis</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Rinorrea</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <v-list
                    v-if="interrogatorioAparato.fk_idCatAparatoSistema === 3"
                    dense
                    color="primary"
                  >
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Disuria</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Poliuria, polaquiuria</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Oliguria</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Tenesmo</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Incontinencia urinaria</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Hematuria</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <v-list
                    v-if="interrogatorioAparato.fk_idCatAparatoSistema === 4"
                    dense
                    color="primary"
                  >
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Intolerancia al frío</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Nerviosismo</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Hiperactividad</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Pérdida de peso</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Caída de cabello</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Polifagia</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Polidipsia</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <v-list
                    v-if="interrogatorioAparato.fk_idCatAparatoSistema === 5"
                    dense
                    color="primary"
                  >
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Cefalea</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Pérdida del estado de alerta</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Síncope</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Mareo</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Vértigo</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Parestesias</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Pérdida de memoria</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Afasias</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Dificultad para deglutir</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <v-list
                    v-if="interrogatorioAparato.fk_idCatAparatoSistema === 6"
                    dense
                    color="primary"
                  >
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Halitosis</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Hematemesis</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Vómito</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Pirosis</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Náuseas</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Disfagia</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Odinofagia</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Diarrea</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Constipación, estreñimientos</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Distención abdominal</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Rectorragia o melena</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <v-list
                    v-if="interrogatorioAparato.fk_idCatAparatoSistema === 7"
                    dense
                    color="primary"
                  >
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Aumento de temperatura</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Calambres</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Artralgias</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Mialgias</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Debilidad muscular</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Lumbalgias, dorsalgias</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Dificultad para la marcha</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="6">
                  <v-textarea
                    v-model="interrogatorioAparato.diagnostico"
                    label="Resultados"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    no-resize
                    rows="9"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>

        <div class="text-h6 font-weight-bold">
          Exploración física
        </div>
        <v-stepper
          v-model="fisicaStepper"
          vertical
          class="primary"
        >
          <v-stepper-step
            editable
            color="secondary"
            step="1"
          >
            Somatometría
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-container>
              <v-row align="center">
                <v-col cols="2">
                  <v-text-field
                    v-model.number="peso"
                    type="number"
                    label="Peso"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    item-color="secondary"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model.number="talla"
                    type="number"
                    label="Talla"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    :value="getImc"
                    label="IMC"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="2">
                  <v-select
                    :value="expediente[0].Personal.fk_idSexo"
                    label="Género"
                    :items="sexo"
                    item-value="id"
                    item-text="title"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    item-color="secondary"
                    readonly
                  />
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="12">
                  <v-subheader class="font-weight-bold">
                    SIGNOS VITALES
                  </v-subheader>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="somatometria.pulso"
                    label="Pulso"
                    number
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="somatometria.frecuenciaCardiaca"
                    label="Frecuencia cardíaca"
                    number
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="somatometria.frecuenciaRespiratoria"
                    label="Frecuencia respiratoria"
                    number
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="somatometria.ta"
                    label="T/A"
                    number
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="somatometria.temperatura"
                    label="Temperatura"
                    number
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <v-text-field
                    v-model="somatometria.habitusExterior"
                    label="Habitus exterior"
                    number
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="somatometria.pa"
                    label="P/A"
                    number
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-btn
                    text
                    rounded
                    class="mx-2"
                    @click="fisicaStepper--"
                  >
                    Anterior
                  </v-btn>
                  <v-btn
                    color="secondary"
                    rounded
                    class="px-8 mx-2"
                    @click="fisicaStepper++"
                  >
                    Siguiente
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>
          <v-stepper-step
            editable
            color="secondary"
            step="2"
          >
            Exploración física
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-container>
              <v-row
                v-for="(region, index) in regionExploracion"
                :key="index"
              >
                <v-col cols="12">
                  <div
                    v-if="region.fk_idCatRegion === 3"
                    class="text-h6"
                  >
                    Abdomen
                  </div>
                  <div
                    v-if="region.fk_idCatRegion === 1"
                    class="text-h6"
                  >
                    Cabeza y cuello
                  </div>
                  <div
                    v-if="region.fk_idCatRegion === 4"
                    class="text-h6"
                  >
                    Sistema locomotor
                  </div>
                  <div
                    v-if="region.fk_idCatRegion === 2"
                    class="text-h6"
                  >
                    Tórax
                  </div>
                  <div
                    v-if="region.fk_idCatRegion === 5"
                    class="text-h6"
                  >
                    Exploración genital
                  </div>
                </v-col>
                <v-col cols="4">
                  <v-checkbox
                    label="Datos patológicos"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    v-model="region.diagnostico"
                    label="¿Cuáles?"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-btn
                    text
                    rounded
                    class="mx-2"
                    @click="fisicaStepper--"
                  >
                    Anterior
                  </v-btn>
                  <v-btn
                    color="secondary"
                    rounded
                    class="px-8 mx-2"
                    @click="fisicaStepper++"
                  >
                    Siguiente
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>

          <v-stepper-step
            editable
            color="secondary"
            step="3"
          >
            Exploración neurológica
          </v-stepper-step>
          <v-stepper-content step="3">
            <v-container>
              <v-row align="center">
                <v-col cols="3">
                  <v-select
                    label="Orientación"
                    :items="orientacion"
                    item-value="id"
                    item-text="title"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    item-color="secondary"
                  />
                </v-col>
                <v-col cols="3">
                  <v-select
                    label="Pupilas"
                    :items="pupilas"
                    item-value="id"
                    item-text="title"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    item-color="secondary"
                  />
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3">
                  <v-select
                    label="Tono muscular"
                    :items="tonoMuscular"
                    item-value="id"
                    item-text="title"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    item-color="secondary"
                  />
                </v-col>
                <v-col cols="3">
                  <v-slider
                    label="Fuerza muscular"
                    color="secondary"
                    ticks
                    step="1"
                    :tick-labels="tonoMuscularLabels"
                    tick-size="5"
                    min="1"
                    max="5"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <v-select
                    label="Reflejos osteotendinosos"
                    :items="reflejosOsteotendinosos"
                    item-value="id"
                    item-text="title"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    item-color="secondary"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-btn
                    text
                    rounded
                    class="mx-2"
                    @click="fisicaStepper--"
                  >
                    Anterior
                  </v-btn>
                  <v-btn
                    color="secondary"
                    rounded
                    class="px-8 mx-2"
                    @click="fisicaStepper++"
                  >
                    Siguiente
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>
          <v-stepper-step
            editable
            color="secondary"
            step="4"
          >
            Agudeza visual y distinción de colores
          </v-stepper-step>
          <v-stepper-content step="4">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-alert
                    type="info"
                    color="secondary"
                  >
                    Evaluación realizada con carta de Snell a 3 mts. de distancia
                  </v-alert>
                </v-col>
                <v-col cols="12">
                  <v-subheader class="font-weight-bold">
                    OJO DERECHO
                  </v-subheader>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="agudezaVisual.pruebas[0].diagnostico"
                    label="Resultado sin anteojos"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="agudezaVisual.pruebas[1].diagnostico"
                    label="Resultado con anteojos"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="agudezaVisual.pruebas[2].diagnostico"
                    label="Resultado con agujero estenopeico"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="12">
                  <v-subheader class="font-weight-bold">
                    OJO IZQUIERDO
                  </v-subheader>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="agudezaVisual.pruebas[3].diagnostico"
                    label="Resultado sin anteojos"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="agudezaVisual.pruebas[4].diagnostico"
                    label="Resultado con anteojos"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="agudezaVisual.pruebas[5].diagnostico"
                    label="Resultado con agujero estenopeico"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="12">
                  <v-subheader class="font-weight-bold">
                    RESULTADOS
                  </v-subheader>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="agudezaVisual.resultado"
                    label="Resultado de percepción a los colores (discromatopsia)"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="8">
                  <!-- <v-slider
                                        v-model="agudezaVisual.percepcionColores"
                                        label="Percepción a los colores"
                                        color="secondary"
                                        ticks
                                        max="14"
                                        min="1"
                                        step="1"
                                        tick-size="5"
                                        :tick-labels="percepciones"
                                    ></v-slider> -->
                  <v-select
                    v-model="percepcionColores"
                    label="Percepción a los colores"
                    rounded
                    filled
                    dense
                    multiple
                    color="secondary"
                    background-color="primary"
                    item-color="secondary"
                    :items="tarjetasPercepcion"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-btn
                    text
                    rounded
                    class="mx-2"
                    @click="fisicaStepper--"
                  >
                    Anterior
                  </v-btn>
                  <v-btn
                    color="secondary"
                    rounded
                    class="px-8 mx-2"
                    @click="fisicaStepper++"
                  >
                    Siguiente
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>

          <v-stepper-step
            editable
            color="secondary"
            step="5"
          >
            Audición
          </v-stepper-step>
          <v-stepper-content step="5">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-subheader class="font-weight-bold">
                    OÍDO IZQUIERDO
                  </v-subheader>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="audicion.pruebas[2].resultado"
                    label="Resultado Renne"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="audicion.pruebas[3].resultado"
                    label="Resultado Weber"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="audicion.resultadoOidoIzquierdo"
                    label="Resultado general"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-subheader class="font-weight-bold">
                    OÍDO DERECHO
                  </v-subheader>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="audicion.pruebas[0].resultado"
                    label="Resultado Renne"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="audicion.pruebas[1].resultado"
                    label="Resultado Weber"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="audicion.resultadoOidoDerecho"
                    label="Resultado general"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-btn
                    text
                    rounded
                    class="mx-2"
                    @click="fisicaStepper--"
                  >
                    Anterior
                  </v-btn>
                  <v-btn
                    color="secondary"
                    rounded
                    class="px-8 mx-2"
                    @click="fisicaStepper++"
                  >
                    Finalizar
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>
        </v-stepper>

        <div class="text-h6 font-weight-bold">
          Resultados
        </div>
        <v-stepper
          v-model="resultadosStepper"
          vertical
          class="primary"
        >
          <v-stepper-step
            editable
            color="secondary"
            step="1"
          >
            Resultados de laboratorio y gabinete
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-container>
              <v-row>
                <v-col
                  cols="6"
                  offset-md="3"
                >
                  <v-textarea
                    v-model="historiaClinica.resultadoLaboratorioGabinete"
                    label="Resultados de laboratorio y gabinete"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    no-resize
                    rows="4"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-btn
                    text
                    rounded
                    class="mx-2"
                    @click="resultadosStepper--"
                  >
                    Anterior
                  </v-btn>
                  <v-btn
                    color="secondary"
                    rounded
                    class="px-8 mx-2"
                    @click="resultadosStepper++"
                  >
                    Siguiente
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>
          <v-stepper-step
            editable
            color="secondary"
            step="2"
          >
            Diagnóstico médico
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-container>
              <v-row>
                <v-col
                  cols="6"
                  offset-md="3"
                >
                  <v-textarea
                    v-model="historiaClinica.diagnosticoMedico"
                    label="Diagnóstico médico"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    no-resize
                    rows="4"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-btn
                    text
                    rounded
                    class="mx-2"
                    @click="resultadosStepper--"
                  >
                    Anterior
                  </v-btn>
                  <v-btn
                    color="secondary"
                    rounded
                    class="px-8 mx-2"
                    @click="resultadosStepper++"
                  >
                    Siguiente
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>
          <v-stepper-step
            editable
            color="secondary"
            step="3"
          >
            Observaciones
          </v-stepper-step>
          <v-stepper-content step="3">
            <v-container>
              <v-row>
                <v-col
                  cols="6"
                  offset-md="3"
                >
                  <v-textarea
                    v-model="historiaClinica.observaciones"
                    label="Observaciones"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    no-resize
                    rows="4"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-btn
                    text
                    rounded
                    class="mx-2"
                    @click="resultadosStepper--"
                  >
                    Anterior
                  </v-btn>
                  <v-btn
                    color="secondary"
                    rounded
                    class="px-8 mx-2"
                    :loading="loading"
                    :disabled="loading || !validHistoriaClinica"
                    @click="triggerSaveHistoriaClinica()"
                  >
                    Registrar historia clínica
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>
        </v-stepper>
      </v-col>
    </v-row>
    <v-overlay
      :value="overlay"
      :z-index="999"
      align="center"
      color="secondary"
      opacity="1"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
      <div class="text-overline mt-4">
        Cargando información. Por favor, espere...
      </div>
    </v-overlay>
  </v-container>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import moment from 'moment';
import EvaluadoInfoCardComponent from '../../components/EvaluadoInfoCardComponent.vue';

export default {
  components: {
    EvaluadoInfoCardComponent,
  },

  props: {
    id: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      overlay: false,

      grupoSanguineoStepper: 1,
      antecedentesHeredoStepper: 1,
      antecedentesPersonalesStepper: 1,
      antecedentesPersonalesPatStepper: 1,
      fisicaStepper: 1,
      resultadosStepper: 1,
      aparatosStepper: 1,

      checkEnfermedades: false,
      checkDrogas: false,
      checkDeporte: false,

      rangoFecha: [],

      tarjetasPercepcion: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14'],
      percepcionColores: [],

      drogasConsumidasHeaders: [
        { text: 'Droga consumida', value: 'droga', width: '10%' },
        { text: 'Motivo', value: 'motivo', width: '20%' },
        { text: 'Edad a la que consumió', value: 'edadConsumo', width: '10%' },
        { text: 'Cantidad que consumió', value: 'cantidadConsumo', width: '10%' },
        { text: 'Última vez que la consumió', value: 'ultimoConsumo', width: '10%' },
        {
          text: '¿Consume actualmente?', value: 'consumoActual', width: '5%', align: 'center',
        },
        { text: '¿Combinó con alcohol?', value: 'combinacionConAlcohol', width: '5%' },
        { text: '¿Consumió en compañía?', value: 'consumoCompania', width: '25%' },
        { text: 'Opciones', value: 'opciones', width: '5%' },
      ],
      medicamentosConsumidosHeaders: [
        { text: 'Medicamento consumido', value: 'medicamento', width: '15%' },
        { text: 'Recetado por', value: 'receto', width: '25%' },
        { text: 'Cuenta con receta', value: 'tieneReceta', width: '5%' },
        { text: 'Fecha de consumo', value: 'fechaInicio', width: '10%' },
        { text: 'Lugar donde consiguió', value: 'lugarConsiguio', width: '20%' },
        { text: 'Dosis indicada', value: 'dosisDetalle', width: '20%' },
        { text: 'Opciones', value: 'opciones', width: '5%' },
      ],
      medicamentosActualesHeaders: [
        { text: 'Medicamento', value: 'medicamento', width: '25%' },
        { text: '¿Medicación actual?', value: 'medicacionActual', width: '10%' },
        { text: '¿Medicamento controlado?', value: 'controlado', width: '10%' },
        { text: 'Fecha de consumo', value: 'fecha', width: '30%' },
        { text: 'Diagnóstico de tratamiento', value: 'diagnosticoTratamiento', width: '30%' },
        { text: 'Opciones', value: 'opciones', width: '5%' },
      ],
      enfermedadesActualesHeaders: [
        { text: 'Enfermedad', value: 'enfermedad', width: '10%' },
        { text: 'Fecha de inicio', value: 'fechaInicio', width: '20%' },
        { text: 'Fecha de fin', value: 'fechaFin', width: '20%' },
        { text: '¿Recibió tratamiento médico-farmacológico?', value: 'detalle', width: '45%' },
        { text: 'Opciones', value: 'opciones', width: '5%' },
      ],
      deportesHeaders: [
        { text: 'Deporte o ejercicio', value: 'tipoEjercicio', width: '10%' },
        { text: 'Tiempo', value: 'fk_idTiempo', width: '20%' },
        { text: 'Frecuencia', value: 'fk_idFrecuencia', width: '65%' },
        { text: 'Opciones', value: 'opciones', width: '5%' },
      ],
      zoonosisHeaders: [
        { text: 'Zoonosis', value: 'title', width: '20%' },
        { text: 'Detalle', value: 'detalle', width: '75%' },
        { text: 'Opciones', value: 'opciones', width: '5%' },
      ],
      antecedentesHeredofamiliaresHeaders: [
        { text: 'Patología / Enfermedad', value: 'title' },
        { text: 'Madre', value: 'madre' },
        { text: 'Padre', value: 'padre' },
        { text: 'Abuelos', value: 'abuelos' },
        { text: 'Hermanos', value: 'hermanos' },
      ],

      antecedentesHeredofamiliares: [],

      enfermedadesActuales: [],

      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      date3: new Date().toISOString().substr(0, 10),
      date4: new Date().toISOString().substr(0, 10),
      date5: new Date().toISOString().substr(0, 10),
      date6: new Date().toISOString().substr(0, 10),
      date7: new Date().toISOString().substr(0, 10),
      date8: new Date().toISOString().substr(0, 10),
      date9: new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      dateFormatted2: this.formatDate(new Date().toISOString().substr(0, 10)),
      dateFormatted3: this.formatDate(new Date().toISOString().substr(0, 10)),
      dateFormatted4: this.formatDate(new Date().toISOString().substr(0, 10)),
      dateFormatted5: this.formatDate(new Date().toISOString().substr(0, 10)),
      dateFormatted6: this.formatDate(new Date().toISOString().substr(0, 10)),
      dateFormatted7: this.formatDate(new Date().toISOString().substr(0, 10)),
      dateFormatted8: this.formatDate(new Date().toISOString().substr(0, 10)),
      dateFormatted9: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      menu6: false,
      menu7: false,
      menu8: [],
      menu9: [],
      fechaUltimoConsumoDroga: [],
      fechaConsumoMedicamentoControlado: [],
      ultimaMestruacionMenu: false,
      inicioVidaSexualMenu: false,
      deteccionCancerMenu: false,
      ultimoPartoMenu: false,
      ultimaCesareaMenu: false,
      fechaMedicamentoActualMenu: [],

      listaTatuajes: [],
      listaPerforaciones: [],

      frecuencias: ['1 vez al mes', 'Cada 15 días', '1 vez a la semana', '2-3 veces a la semana', 'Diario'],

      percepciones: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14'],
      tonoMuscularLabels: ['1', '2', '3', '4', '5'],

      // HISTORIA CLINICA
      historiaClinica: {
        idExpediente: this.id,
        fk_idCatGrupoSanguineo: null,
        fk_idCatServicioMedico: null,
        incapacidadVidaLaboral: false,
        motivoIncapacidad: '',
        tatuajesPerforaciones: true,
        resultadoLaboratorioGabinete: '',
        diagnosticoMedico: '',
        observaciones: '',
        fecha: moment().format('DD/MM/YYYY'),
      },

      // ACCIDNETE LABORAL
      checkAccidentesLaborales: false,
      accidenteLaboral: {
        descripcion: '',
        fk_idCatTiempo: null,
        complicacionesDerivadas: false,
        detalleComplicacionesDerivadas: '',
      },

      // EJERCICIO
      deportes: [],

      // DIETA
      carnes: {
        fk_idCatFrecuencia: 0,
        fk_idCatGrupoAlimentos: 2,
        otra: '',
      },
      cereales: {
        fk_idCatFrecuencia: 0,
        fk_idCatGrupoAlimentos: 3,
        otra: '',
      },
      frutas: {
        fk_idCatFrecuencia: 0,
        fk_idCatGrupoAlimentos: 1,
        otra: '',
      },
      lacteos: {
        fk_idCatFrecuencia: 0,
        fk_idCatGrupoAlimentos: 4,
        otra: '',
      },

      // ZOONOSIS
      zoonosis: [],

      // ANTECEDENTES PATOLOGICOS
      patologico: {
        hospitalizacion: false,
        detalleHospitalizacion: '',
        quirurgicos: false,
        detalleQuirurgicos: '',
        trasfuncionales: false,
        detalleTransfucionales: '',
        rehabilitacionFisica: false,
        detalleRehabilitacionFisica: '',
        alergias: false,
        detalleAlergias: '',
        terapiaPsicologica: false,
        detalleTerapiaPsicologica: '',
        terapiaPsiquiatrica: false,
        detalleTerapiaPsiquiatrica: '',
        ultimaVacuna: '',
        drogas: [],
        enfermedades: [],
        medicamentosControlados: [],
        consumosTabaco: [
          {
            fk_idFrecuencia: 1,
            edadInicio: 0,
            cantidadConsumo: 0,
          },
        ],
        consumosAlcohol: [
          {
            fk_idCatFrecuencia: 1,
            fk_idCatTipoBebida: null,
            fk_idCatNivelConsumoAlcohol: null,
            edadInicio: 0,
            cantidad: 0,
            problemasGenerados: '',
          },
        ],
      },

      // ANTECEDENTES ANDROGENICOS
      androgenicos: {
        ivsa: '',
        noParejasSexuales: 0,
        antecedentesETS: '',
        inicioPubertad: 0,
        metodoPlanificacion: '',
        deteccionCancerProstatico: null,
      },

      // ANTECEDENTES GINECO OBSTETRICOS
      gineco: {
        menarca: '',
        ciclos: '',
        noGestas: 0,
        partos: 0,
        cesareas: 0,
        abortos: 0,
        ultimaMestruacion: null,
        inicioVidaSexual: null,
        noParejasSexuales: 0,
        metodoPlanificacion: '',
        deteccionCancer: null,
        ets: '',
        ultimoParto: null,
        ultimaCesarea: null,
      },

      // MEDICACIONES
      medicamentosActuales: [],

      // SOAMTOMETRIA
      peso: 0,
      talla: 0,

      somatometria: {
        peso: '',
        talla: '',
        imc: '',
        pulso: '',
        frecuenciaCardiaca: '',
        frecuenciaRespiratoria: '',
        ta: '',
        temperatura: '',
        habitusExterior: '',
        pa: '',
        fk_idCatsexo: null,
      },

      // PRUEBA AUDICION
      audicion: {
        resultadoOidoDerecho: '',
        resultadoOidoIzquierdo: '',
        pruebas: [
          {
            fk_idCatOido: 1,
            fk_idCatPruebaOido: 1,
            resultado: '',
          },
          {
            fk_idCatOido: 1,
            fk_idCatPruebaOido: 2,
            resultado: '',
          },
          {
            fk_idCatOido: 2,
            fk_idCatPruebaOido: 1,
            resultado: '',
          },
          {
            fk_idCatOido: 2,
            fk_idCatPruebaOido: 2,
            resultado: '',
          },
        ],
      },

      // PRUEBA AGUDEZA VISUAL
      agudezaVisual: {
        percepcionColores: '',
        resultado: '',
        pruebas: [
          {
            fk_idCatOjos: 1,
            fk_idCatPruebaOjos: 1,
            diagnostico: '',
          },
          {
            fk_idCatOjos: 1,
            fk_idCatPruebaOjos: 2,
            diagnostico: '',
          },
          {
            fk_idCatOjos: 1,
            fk_idCatPruebaOjos: 3,
            diagnostico: '',
          },
          {
            fk_idCatOjos: 2,
            fk_idCatPruebaOjos: 1,
            diagnostico: '',
          },
          {
            fk_idCatOjos: 2,
            fk_idCatPruebaOjos: 2,
            diagnostico: '',
          },
          {
            fk_idCatOjos: 2,
            fk_idCatPruebaOjos: 3,
            diagnostico: '',
          },
        ],
      },
    };
  },

  computed: {
    ...mapGetters('expediente', {
      expediente: 'getExpedientesPersonal',
    }),

    ...mapGetters('grupoSanguineo', {
      grupoSanguineo: 'getGrupoSanguineo',
    }),

    ...mapGetters('servicioMedico', {
      servicioMedico: 'getServicioMedico',
    }),

    ...mapGetters('tiempo', {
      tiempos: 'getTiempo',
    }),

    ...mapGetters('tipoVivienda', {
      tipoVivienda: 'getTipoVivienda',
    }),

    ...mapGetters('tipoEjercicio', {
      tipoEjercicio: 'getListaEjercicio',
    }),

    ...mapGetters('enfermedad', {
      listaEnfermedades: 'getListaEnfermedades',
    }),

    ...mapGetters('tipoZoonosis', {
      tipoZoonosis: 'getListaZoonosis',
    }),

    ...mapGetters('droga', {
      listaDrogas: 'getListaDrogas',
    }),

    ...mapGetters('medicamento', {
      listaMedicamentosControlados: 'getListaMedicamentosControlados',
      listaMedicamentosActuales: 'getListaMedicamentosActuales',
    }),

    ...mapGetters('tipoBebida', {
      tipoBebida: 'getTipoBebida',
    }),

    ...mapGetters('peso', {
      listaPeso: 'getPeso',
    }),

    ...mapGetters('talla', {
      listaTalla: 'getTalla',
    }),

    ...mapGetters('sexo', {
      sexo: 'getSexo',
    }),

    ...mapGetters('orientacion', {
      orientacion: 'getOrientacion',
    }),

    ...mapGetters('pupilas', {
      pupilas: 'getPupilas',
    }),

    ...mapGetters('tonoMuscular', {
      tonoMuscular: 'getTonoMuscular',
    }),

    ...mapGetters('reflejosOsteotendinosos', {
      reflejosOsteotendinosos: 'getReflejosOsteotendinosos',
    }),

    ...mapGetters('pruebaOjos', {
      pruebaOjos: 'getPruebaOjos',
    }),

    ...mapGetters('ojos', {
      ojos: 'getOjos',
    }),

    ...mapGetters('pruebaOido', {
      pruebaOido: 'getPruebaOido',
    }),

    ...mapGetters('oido', {
      oidos: 'getOido',
    }),

    ...mapGetters('patologicas', {
      patologicas: 'getPatologicas',
    }),

    ...mapGetters('parentesco', {
      parentesco: 'getParentesco',
    }),

    // TIPO DIETA
    ...mapGetters('grupoAlimentos', {
      grupoAlimentos: 'getListaGrupoAlimentos',
    }),

    ...mapGetters('tipoServicio', {
      tipoServicio: 'getTipoServicio',
    }),

    ...mapGetters('frecuencia', {
      frecuenciasLista: 'getFrecuencia',
    }),

    ...mapGetters('nivelConsumoAlcohol', {
      nivelConsumoAlcohol: 'getNivelConsumoAlcohol',
    }),

    ...mapGetters('historiaClinica', {
      idHistoriaClinica: 'getIdHistoriaClinica',
    }),

    ...mapGetters('aparatoSistema', {
      aparatoSistema: 'getAparatoSistema',
      interrogatorioAS: 'getInterrogatorio',
    }),

    ...mapGetters('imc', {
      imc: 'getImc',
    }),

    ...mapGetters('region', {
      regiones: 'getRegion',
      regionExploracion: 'getRegionExploracion',
    }),

    filteredTiempoHoras() {
      return this.tiempos.filter((tiempo) => tiempo.id === 1 || tiempo.id === 2 || tiempo.id === 3);
    },

    validHistoriaClinica() {
      if (
        this.grupoSanguineoStepper < 2
                    || this.antecedentesPersonalesStepper < 4
                    || this.antecedentesPersonalesPatStepper < 9
                    || this.fisicaStepper < 5
      ) {
        return false;
      } return true;
    },

    stringPercepcionColores() {
      let percepcion = '';

      if (this.percepcionColores.length > 0) {
        this.percepcionColores.forEach((tarjeta) => {
          percepcion = `${percepcion}, ${tarjeta}`;
        });

        percepcion = percepcion.substring(2);
      }

      return percepcion;
    },

    getImc() {
      if (this.peso !== 0 && this.talla !== 0) {
        return (this.peso / (this.talla * this.talla).toFixed(2)).toFixed(2);
      } return 0;
    },
  },

  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
  },

  async mounted() {
    this.overlay = true;
    await this.fetchExpedienteById(this.id);
    await this.fetchGrupoSanguineo();
    await this.fetchServicioMedico();
    await this.fetchTiempo();
    await this.fetchTipoVivienda();
    await this.fetchTipoEjercicio();
    await this.fetchEnfermedad();
    await this.fetchTipoZoonosis();
    await this.fetchDroga();
    await this.fetchMedicamento();
    await this.fetchTipoBebida();
    await this.fetchPeso();
    await this.fetchTalla();
    await this.fetchSexo();
    await this.fetchOrientacion();
    await this.fetchPupilas();
    await this.fetchTonoMuscular();
    await this.fetchReflejosOsteotendinosos();
    await this.fetchPruebaOjos();
    await this.fetchOjos();
    await this.fetchPruebaOido();
    await this.fetchOido();
    await this.fetchPatologicas();
    await this.fetchParentesco();
    await this.fetchGrupoAlimentos();
    await this.fetchTipoServicio();
    await this.fetchFrecuencia();
    await this.fetchNivelConsumoAlcohol();
    await this.fetchParentescoHeredoFamiliar();
    await this.fetchAparatoSistema();
    await this.fetchImc();
    await this.fetchRegion();
    this.overlay = false;
  },

  methods: {
    ...mapActions('expediente', ['fetchExpedienteById']),
    ...mapActions('grupoSanguineo', ['fetchGrupoSanguineo']),
    ...mapActions('servicioMedico', ['fetchServicioMedico']),
    ...mapActions('tiempo', ['fetchTiempo']),
    ...mapActions('tipoVivienda', ['fetchTipoVivienda']),
    ...mapActions('tipoEjercicio', ['fetchTipoEjercicio']),
    ...mapActions('enfermedad', ['fetchEnfermedad']),
    ...mapActions('tipoZoonosis', ['fetchTipoZoonosis']),
    ...mapActions('droga', ['fetchDroga']),
    ...mapActions('medicamento', ['fetchMedicamento']),
    ...mapActions('tipoBebida', ['fetchTipoBebida']),
    ...mapActions('peso', ['fetchPeso']),
    ...mapActions('talla', ['fetchTalla']),
    ...mapActions('sexo', ['fetchSexo']),
    ...mapActions('orientacion', ['fetchOrientacion']),
    ...mapActions('pupilas', ['fetchPupilas']),
    ...mapActions('tonoMuscular', ['fetchTonoMuscular']),
    ...mapActions('reflejosOsteotendinosos', ['fetchReflejosOsteotendinosos']),
    ...mapActions('pruebaOjos', ['fetchPruebaOjos']),
    ...mapActions('ojos', ['fetchOjos']),
    ...mapActions('pruebaOido', ['fetchPruebaOido']),
    ...mapActions('oido', ['fetchOido']),
    ...mapActions('patologicas', ['fetchPatologicas']),
    ...mapActions('parentesco', ['fetchParentesco']),
    ...mapActions('grupoAlimentos', ['fetchGrupoAlimentos']),
    ...mapActions('tipoServicio', ['fetchTipoServicio']),
    ...mapActions('frecuencia', ['fetchFrecuencia']),
    ...mapActions('nivelConsumoAlcohol', ['fetchNivelConsumoAlcohol']),
    ...mapActions('tipoZoonosis', ['fetchTipoZoonosis']),

    ...mapActions('historiaClinica', ['saveHistoriaClinica']),
    ...mapActions('accidenteLaboral', ['saveAccidenteLaboral']),
    ...mapActions('antecedentesPatologicos', ['saveAntecedentesPatologicos']),
    ...mapActions('antecedentesAndrogenicos', ['saveAntecedentesAndrogenicos']),
    ...mapActions('antecedentesGinecoObstetricos', ['saveAntecedentesGinecoObstetricos']),
    ...mapActions('audiciones', ['saveAudiciones']),
    ...mapActions('agudezasVisuales', ['saveAgudezasVisuales']),
    ...mapActions('ejercicio', ['saveEjercicio']),
    ...mapActions('zoonosis', ['saveZoonosis']),
    ...mapActions('medicacionActual', ['saveMedicacionActual']),

    ...mapActions('parentescoHeredoFamiliar', ['fetchParentescoHeredoFamiliar']),
    ...mapActions('antecedentesHeredoFamiliares', ['saveAntecedentesHeredoFamiliares']),
    ...mapActions('aparatoSistema', ['fetchAparatoSistema']),

    ...mapActions('somatometria', ['saveSomatometria']),
    ...mapActions('imc', ['fetchImc']),
    ...mapActions('region', ['fetchRegion']),
    ...mapActions('interrogatorioAS', ['saveInterrogatorioAS']),
    ...mapActions('regionExploracion', ['saveRegionExploracion']),

    ...mapActions('tipoDieta', ['saveTipoDieta']),

    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    getCantidadDias() {
      const inicio = moment(this.rangoFecha[0]);
      const fin = moment(this.rangoFecha[1]);

      return fin.diff(inicio, 'days');
    },

    quitaDroga(droga) {
      const index = this.patologico.drogas.indexOf(droga);
      this.patologico.drogas.splice(index, 1);
    },

    quitaMedicamento(medicamento) {
      const index = this.patologico.medicamentosControlados.indexOf(medicamento);
      this.patologico.medicamentosControlados.splice(index, 1);
    },

    quitaMedicamentoActual(medicamento) {
      const index = this.medicamentosActuales.indexOf(medicamento);
      this.medicamentosActuales.splice(index, 1);
    },

    quitaEnfermedadActual(enfermedad) {
      const index = this.patologico.enfermedades.indexOf(enfermedad);
      this.patologico.enfermedades.splice(index, 1);
    },

    quitaDeporte(deporte) {
      const index = this.deportes.indexOf(deporte);
      this.deportes.splice(index, 1);
    },

    quitaZoonosis(zoonosis) {
      const index = this.zoonosis.indexOf(zoonosis);
      this.zoonosis.splice(index, 1);
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },

    async triggerSaveHistoriaClinica() {
      this.loading = true;
      this.overlay = true;

      await this.saveHistoriaClinica(this.historiaClinica);
      await this.saveAccidenteLaboral(this.accidenteLaboral);
      await this.saveEjercicio(this.deportes);

      await this.saveTipoDieta(this.carnes);
      await this.saveTipoDieta(this.frutas);
      await this.saveTipoDieta(this.cereales);
      await this.saveTipoDieta(this.lacteos);

      await this.saveAntecedentesHeredoFamiliares(this.antecedentesHeredofamiliares);

      await this.saveZoonosis(this.zoonosis);

      this.medicamentosActuales.forEach((medicamento) => {
        // eslint-disable-next-line no-param-reassign
        medicamento.fechaInicio = moment(medicamento.fechaInicioFin[0]).format('DD/MM/YYYY');
        // eslint-disable-next-line no-param-reassign
        medicamento.fechaFinal = moment(medicamento.fechaInicioFin[1]).format('DD/MM/YYYY');
      });
      await this.saveMedicacionActual(this.medicamentosActuales);

      this.patologico.drogas.forEach((droga) => {
        // eslint-disable-next-line no-param-reassign
        droga.ultimoConsumo = moment(droga.ultimoConsumo).format('DD/MM/YYYY');
      });
      this.patologico.enfermedades.forEach((enfermedad) => {
        // eslint-disable-next-line no-param-reassign
        enfermedad.fechaInicio = moment(enfermedad.fechaInicio).format('DD/MM/YYYY');
        // eslint-disable-next-line no-param-reassign
        enfermedad.fechaFin = moment(enfermedad.fechaFin).format('DD/MM/YYYY');
      });
      this.patologico.medicamentosControlados.forEach((medicamento) => {
        // eslint-disable-next-line no-param-reassign
        medicamento.fechaInicio = moment(medicamento.fechaInicio).format('DD/MM/YYYY');
      });
      await this.saveAntecedentesPatologicos(this.patologico);

      await this.saveRegionExploracion(this.regionExploracion);

      if (this.expediente[0].Personal.fk_idSexo === 1) {
        this.androgenicos.deteccionCancerProstatico = this.androgenicos.deteccionCancerProstatico
          ? moment(this.androgenicos.deteccionCancerProstatico).format('DD/MM/YYYY')
          : null;
        await this.saveAntecedentesAndrogenicos(this.androgenicos);
      } else {
        this.gineco.ultimaMestruacion = this.gineco.ultimaMestruacion ? moment(this.gineco.ultimaMestruacion).format('DD/MM/YYYY') : null;
        this.gineco.inicioVidaSexual = this.gineco.inicioVidaSexual ? moment(this.gineco.inicioVidaSexual).format('DD/MM/YYYY') : null;
        this.gineco.deteccionCancer = this.gineco.deteccionCancer ? moment(this.gineco.deteccionCancer).format('DD/MM/YYYY') : null;
        this.gineco.ultimoParto = this.gineco.ultimoParto ? moment(this.gineco.ultimoParto).format('DD/MM/YYYY') : null;
        this.gineco.ultimaCesarea = this.gineco.ultimaCesarea ? moment(this.gineco.ultimaCesarea).format('DD/MM/YYYY') : null;
        await this.saveAntecedentesGinecoObstetricos(this.gineco);
      }

      await this.saveInterrogatorioAS(this.interrogatorioAS);

      this.somatometria.peso = this.peso.toString();
      this.somatometria.talla = this.talla.toString();
      this.somatometria.imc = this.getImc.toString();

      await this.saveSomatometria(this.somatometria);

      await this.saveAudiciones(this.audicion);
      this.agudezaVisual.percepcionColores = this.stringPercepcionColores;
      await this.saveAgudezasVisuales(this.agudezaVisual);

      this.SET_SNACKBAR_MESSAGE('Historial clínico guardado');
      this.loading = false;
      this.overlay = false;
      this.$router.go(-1);
    },

    toggleAntecedenteHeredofamiliar(event, idEnfermedad, idParentesco) {
      if (event) {
        this.antecedentesHeredofamiliares.push({
          fk_idCatPatologicas: idEnfermedad,
          fk_idCatParentesco: idParentesco,
          respuesta: 'X',
        });
      } else {
        const index = this.antecedentesHeredofamiliares.indexOf({
          fk_idCatPatologicas: idEnfermedad,
          fk_idCatParentesco: idParentesco,
          respuesta: 'X',
        });

        this.antecedentesHeredofamiliares.splice(index, 1);
      }
    },
  },
};
</script>
